<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <s-navbar v-show="loggedIn"></s-navbar>
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body" v-show="loggedIn">
      <s-sidebar></s-sidebar>
      <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div v-if="loggedIn && out_of_version">
          <div class="m-alert m-alert--icon alert alert-warning alert-update" role="alert">
            <div class="m-alert__icon">
              <i class="la la-warning"></i>
            </div>
            <div class="m-alert__text">
              <strong>{{ 'update_title' | translate | capitalize }}</strong> {{ 'update_message' | translate | capitalize }} 	
            </div>
            <div class="m-alert__actions">
              <a href="#" v-if="!validPermission('update','update')" class="btn btn-info m-btn m-btn--icon" @click.prevent="redirectConfiguration">
                <span>
                  <i class="fa flaticon-paper-plane"></i>
                  <span>{{ 'update' | translate | capitalize }}</span>
                </span>
              </a>
            </div>
          </div>
        </div>
        <router-view v-if="loggedIn"></router-view>
      </div>
    </div>
    <s-footer v-show="loggedIn"></s-footer>
    <s-login v-if="!loggedIn"></s-login>
  </div>
</template>

<script>
import SNavbar from '@/components/layout/navbar/Base.vue'
import SSidebar from '@/components/layout/sidebar/Base.vue'
import SFooter from '@/components/layout/Footer.vue'
import SLogin from '@/components/layout/login/Login.vue'
import { mapGetters } from 'vuex'
export default {
  components: { SNavbar, SSidebar, SFooter, SLogin },
  data () {
    return {
      active: false,
      out_of_version: false
    }
  },
  computed: {
    ...mapGetters({loggedIn: 'dataLoggedIn', userData: 'getUserData', getLanguage: 'getLocalLanguage', connection: 'getStatusConnection', permissions: 'getUserPermissions', validPass: 'getValidPass'})
  },
  methods: {
    redirectConfiguration () {
      this.$router.push({name: 'adminConfiguration', params: { update: true }})
    },
    validPermission (action, entity) {
      if (Array.isArray(this.permissions)) {
        if (this.permissions.find(p => { return (p.action === action && p.entity === entity) })) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  mounted () {
    if (this.loggedIn) {
      let local_language = (navigator.language || navigator.userLanguage).substring(0, 2)
      if (Object.keys(this.userData).length > 0) {
        if (this.userData.language !== null) {
          local_language = this.userData.language
        }
      }
      if (local_language !== this.$i18n.locale) {
        this.$i18n.locale = local_language
        this.$validator.localize(local_language)
      }
      this.$store.dispatch('postValidateActivation')
        .then((res) => {
          if (res.data.out_of_version) {
            this.out_of_version = res.data.out_of_version
          }
        })
    } else {
      this.$spinner.show()
      this.$store.dispatch('postValidateActivation')
        .then((res) => {
          if (res.data.out_of_version) {
            this.out_of_version = res.data.out_of_version
          }
          if (res.data.active && parseInt(res.data.sync) === 1) {
            this.$router.push({name: 'activate', params: { sync: true }})
            this.$store.commit('setFirstSync', true)
          } else if (this.validPass === 'false') {
            console.log('Redirect')
          } else {
            this.$router.push({name: !res.data.active ? 'activate' : 'login'})
          }
          this.$spinner.remove()
        })
        .catch((err) => {
          this.$spinner.remove()
          console.log(err)
        })
    }
  },
  watch: {
    // this.$toast(this.$options.filters.capitalize('text_disconnection'), 4)
    /*
    connection (newVal) {
      if (newVal) {
        swal({
          type: 'error',
          title: `<span style="font-size: 2.3rem;">${this.$options.filters.capitalize('tittle_disconnection')}</span>`,
          html: `<span style="font-size: 1.8rem;">${this.$options.filters.capitalize('text_disconnection')}</span>`,
          confirmButtonText: `<span style="font-size: 1.2rem;">${this.$options.filters.capitalize('OK')}</span>`,
          allowOutsideClick: false,
          allowEscapeKey: false,
          width: 800,
          padding: '5em'
        })
      }
    }
    */
  }
}
</script>

<style scoped>
p {
  font-size: 2em;
  text-align: center;
}

.alert-update {
  margin: 20px 40px 0px 40px;
}
</style>



// WEBPACK FOOTER //
// App.vue